import { render, staticRenderFns } from "./tabTon.vue?vue&type=template&id=3f3bfd4c&scoped=true"
import script from "./tabTon.vue?vue&type=script&lang=js"
export * from "./tabTon.vue?vue&type=script&lang=js"
import style0 from "./tabTon.vue?vue&type=style&index=0&id=3f3bfd4c&prod&scoped=true&style=stylus&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3bfd4c",
  null
  
)

export default component.exports